// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rs-6";
export var imgContainer = "_rs-3";
export var menuIcon = "_rs-5";
export var pillWrapper = "_rs-2";
export var pillsContainer = "_rs-1";
export var subscriptionCard = "_rs-0";
export var subscriptionLogo = "_rs-4";